"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNonsecureService = void 0;
const axios_1 = __importDefault(require("axios"));
const injection_symbols_1 = require("./injection-symbols");
/**
 * Creates the commweb service composable instance, for use as a plugin in the Vue app.
 */
function createNonsecureService(options) {
    var _a;
    // Axios instance for commercial web microservice calls.
    const client = axios_1.default.create({
        timeout: (_a = options === null || options === void 0 ? void 0 : options.timeout) !== null && _a !== void 0 ? _a : 70000,
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
    /**
     * Update the options used on service creation.
     */
    function useOptions(options) {
        if (options.timeout) {
            client.defaults.timeout = options.timeout;
        }
    }
    // Build the plugin object.
    const nonsecureService = {
        client,
        useOptions,
        install(app) {
            app.provide(injection_symbols_1.nonsecureServiceKey, nonsecureService);
            app.provide(injection_symbols_1.nonsecureServiceClientKey, client);
        }
    };
    return nonsecureService;
}
exports.createNonsecureService = createNonsecureService;
//# sourceMappingURL=nonsecure-service.js.map